import {
  Slider as SliderCore,
  SliderItem,
  SliderDrag,
  SliderBtn,
  SliderDots,
  SliderCount,
} from '@studiometa/ui';

/**
 * Slider component
 */
export default class Slider extends SliderCore {
  /**
   * Component Configuration
   */
  static config = {
    name: 'Slider',
    components: {
      SliderItem,
      SliderDrag,
      SliderDots,
      SliderBtn,
      SliderCount,
    },
  };
}
